import React from "react";
import {
  FlatButton,
  RaisedButton,
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui";
import styled from "styled-components";
import * as TimeUtils from "../../../general/time-utils";

export default class ContractsTable extends React.Component {
  render() {
    return (
      <div>
        <Table selectable={false} fixedHeader={false} style={{ width: "100%" }}>
          <TableBody displayRowCheckbox={false} showRowHover={true}>
            <TableRow>
              <TableHeaderColumn>Nr ctr</TableHeaderColumn>
              <TableHeaderColumn>Tip</TableHeaderColumn>
              <TableHeaderColumn>Denumire</TableHeaderColumn>
              <TableHeaderColumn>Nr. contract</TableHeaderColumn>
              <TableHeaderColumn>
                Obiect
                <br />
                contract
              </TableHeaderColumn>
              <TableHeaderColumn>
                Nr.
                <br />
                Referat
              </TableHeaderColumn>
              <TableHeaderColumn>Furnizor</TableHeaderColumn>
              <TableHeaderColumn>
                Valoarea
                <br />
                prevazuta
                <br />
                in contract
              </TableHeaderColumn>
              <TableHeaderColumn>
                Data de
                <br />
                inceput
              </TableHeaderColumn>
              <TableHeaderColumn>
                Data de
                <br />
                finalizare
              </TableHeaderColumn>
              <TableHeaderColumn>
                Valoarea
                <br />
                (cu TVA)
              </TableHeaderColumn>
              <TableHeaderColumn />
            </TableRow>

            {this.props.data.map((el, i) => {
              return (
                <TableRow key={el.id}>
                  <TableRowColumn>{i + 1}</TableRowColumn>
                  <TableRowColumn>{el.type}</TableRowColumn>
                  <TableRowColumn>{el.serviceName}</TableRowColumn>
                  <TableRowColumn>
                    {el.contractNr +
                      "/" +
                      TimeUtils.getSimpleDotsFormat(el.contractDate)}
                  </TableRowColumn>
                  <TableRowColumn>{el.contractObject}</TableRowColumn>
                  <TableRowColumn>{el.purchaseRequisitionNr}</TableRowColumn>
                  <TableRowColumn>{el.supplier}</TableRowColumn>
                  <TableRowColumn>{el.contractValue}</TableRowColumn>
                  <TableRowColumn>
                    {TimeUtils.getSimpleDotsFormat(el.startDate)}
                  </TableRowColumn>
                  <TableRowColumn>
                    {TimeUtils.getSimpleDotsFormat(el.endDate)}
                  </TableRowColumn>
                  <TableRowColumn>{el.paymentValueWithVat}</TableRowColumn>
                  <TableRowColumn>
                    <div>
                      <RaisedButton
                        primary
                        label={"Detalii"}
                        onClick={() => this.props.onDetailsClicked(el)}
                      />
                    </div>
                  </TableRowColumn>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}
